'use strict';

import angular from 'angular';
/*import 'ui-select';*/

import AccountCommonController from './account_common.controller';
import AccountModifyController from './account_modify.controller';
import AccountNewController from './account_new.controller';

import 'angular-recaptcha';

export default angular.module('everlaps.account', ['vcRecaptcha'/*, 'ui.select'*/])
	.controller('AccountCommonController', AccountCommonController)
	.controller('AccountModifyController', AccountModifyController)
	.controller('AccountNewController', AccountNewController)
	.run(function($templateCache) {
		'ngInject';
		// http://blog.johnnyreilly.com/2016/05/inlining-angular-templates-with-webpack.html
		$templateCache.put("account_common.html", require("./account_common.html"));
		//$templateCache.put("AccountCommonController", require("./account-common/account_common.controller.js"));
	})
	/*.config(function(vcRecaptchaServiceProvider) {
		'ngInject';
		vcRecaptchaServiceProvider.setSiteKey('6Lfk89cSAAAAALYE8fl-R8iaRaPKkhSQXdkaDf7i');
		vcRecaptchaServiceProvider.setTheme('light')
		//vcRecaptchaServiceProvider.setStoken('--- YOUR GENERATED SECURE TOKEN ---')
		vcRecaptchaServiceProvider.setSize('normal')
		//vcRecaptchaServiceProvider.setType('---- audio or image ----')
		//vcRecaptchaServiceProvider.setLang('---- language code ----')
	})*/
	.name;



// WEBPACK FOOTER //
// ./client/app/account/account/index.js